import styled from 'styled-components'

export const LabelBadgeStyled = styled.span`
  display: inline-flex;
  margin-left: ${(props) => props.theme.typography.pxToRem(8)};
  vertical-align: middle;
`
